import * as firebase from 'firebase';
import 'firebase/firestore';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyAolv2WtLGwY4atmVlMbmMSv5tiqYKSxUA",
    authDomain: "apollo-protocol.firebaseapp.com",
    databaseURL: "https://apollo-protocol.firebaseio.com",
    projectId: "apollo-protocol",
    storageBucket: "apollo-protocol.appspot.com",
    messagingSenderId: "650409925894"
});

const auth = firebaseApp.auth(); 
const db = firebaseApp.firestore();

export { db, auth };


// WEBPACK FOOTER //
// ./src/util/firebase.js